const SPECIALITY = {
    OTHERS: 28,
};

export default SPECIALITY